import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { NetworkService } from '../../services/network/network.service';

export const authGuard: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    console.debug(inject(PwaService).isPwa(), !inject(NetworkService).isOnline);
   return inject(AuthService).isLoggedIn || (inject(PwaService).isPwa() && !inject(NetworkService).isOnline);
  };
